
export enum TIPO_CLIENTE {
    JURIDICA = 1,
    NATURAL,
    EXTRANJERO,
    EXTRANJERO_JURIDICO,
    CEDULA_IDENTIDAD,
    NATURAL_SIN_DOCUMENTO,
    JURIDICA_SIN_DOCUMENTO
};

export const IDS_TIPO_CLIENTE_JURIDICO = [TIPO_CLIENTE.JURIDICA,TIPO_CLIENTE.EXTRANJERO_JURIDICO,TIPO_CLIENTE.JURIDICA_SIN_DOCUMENTO];


const IDS_EMISION_EXTERNA = [3, 5];
